import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { MainLayout } from '../../components/MainLayout';
import { TeamCard } from '../../features/teams/components/TeamCard';
import { CreateTeamModal } from '../../features/teams/components/CreateTeamModal';
import { useTeams } from '../../hooks/useTeams';

export function TeamsPage() {
  const { teams, loading, reload: loadTeams } = useTeams();
  const [error] = useState<string | null>(null);

  // Check if we should open create modal from query param
  const params = new URLSearchParams(window.location.search);
  const shouldCreate = params.get('create') === 'true';
  const [showCreateModal, setShowCreateModal] = useState(shouldCreate);

  // Auto-redirect to team if user only has one team (skip if creating)
  // Auto-redirect new users straight to onboarding (no intermediate welcome screen)
  useEffect(() => {
    if (loading) return;
    if (teams.length === 0 && !shouldCreate) {
      route('/onboarding');
    } else if (teams.length === 1 && !shouldCreate) {
      route(`/teams/${teams[0].teamId}`);
    }
  }, [loading, teams]);


  const handleCreateTeam = () => {
    setShowCreateModal(true);
  };

  const handleTeamCreated = () => {
    loadTeams(); // Reload teams after creation
    setShowCreateModal(false);
  };


  if (loading) {
    return (
      <MainLayout>
        <div class="flex items-center justify-center h-full">
          <span class="loading loading-spinner loading-lg"></span>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div class="flex-1 overflow-auto">
        <div class="container mx-auto p-8 max-w-6xl">
        {teams.length > 0 && (
          <div class="flex justify-between items-center mb-8">
            <div>
              <h1 class="text-3xl font-bold">Teams</h1>
              <p class="text-base-content/70 mt-2">
                Collaborate with your team members on AI projects
              </p>
            </div>

            <button
              onClick={handleCreateTeam}
              class="btn btn-primary"
            >
              <span class="text-lg">+</span>
              Create Team
            </button>
          </div>
        )}

        {/* Only show payment banner if user actually tries to use restricted features */}

        {error && (
          <div class="alert alert-error mb-6">
            <span>{error}</span>
          </div>
        )}

        {/* Teams Grid */}
        {teams.length === 0 ? (
          <div class="flex items-center justify-center h-64">
            <span class="loading loading-spinner loading-lg"></span>
          </div>
        ) : (
          <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {teams.map((team) => (
              <TeamCard
                key={team.teamId}
                team={team}
                onTeamUpdate={loadTeams}
              />
            ))}
          </div>
        )}

        {/* Remove feature limitations section - too much noise */}
        </div>
      </div>

      {/* Modals */}
      {showCreateModal && (
        <CreateTeamModal
          onClose={() => setShowCreateModal(false)}
          onTeamCreated={handleTeamCreated}
        />
      )}
    </MainLayout>
  );
}
